// extracted by mini-css-extract-plugin
export default {"container":"Tk-z","bubbleNav":"Uk-z","graphic":"Vk-z","contact":"Wk-z"};